import api from "../utils/axiosInstance";
import { GET_USER_DETAIL, GET_USER_DETAIL_ERROR, GET_USER_DETAIL_REQUEST, UPDATE_USER_DETAIL_DATA, REMOVE_USER_DETAIL_DATA, REMOVE_USER_NAME_DATA } from "../ActionTypes/ActionTypes.js";
const getUserDetailRequest = () => ({ type: GET_USER_DETAIL_REQUEST });
const getUserDetailSuccess = (data) => ({ type: GET_USER_DETAIL, payload: data });
const getUserDetailError = (error) => ({ type: GET_USER_DETAIL_ERROR, payload: error });

export const getUserDetail = () => async (dispatch) => {
  dispatch(getUserDetailRequest());
  try {
    const response = await api.post(`/user/getdetails`);

    if (response?.data?.success) {
      dispatch(getUserDetailSuccess(response.data?.result));
    } else {
      dispatch(getUserDetailError(response?.data?.message));
    }
  } catch (error) {
    dispatch(getUserDetailError(error.response?.data?.message || error.message));
  }
};


export const updateUserDetailData = (newData) => ({
  type: UPDATE_USER_DETAIL_DATA,
  payload: newData,
});



export const updateUser = (formData) => async (dispatch) => {
  try {
    const response = await api.post(`/user/updateuser`, formData);
    if (response.data.success) {
      dispatch(updateUserDetailData(response.data.result));
    }
    return response.data;
  } catch (error) {
    console.error(error);
    return { success: false, message: "Server error" };
  }
};


export const removeUserDetailData = (newData) => ({
  type: REMOVE_USER_DETAIL_DATA,
  payload: newData,
});

export const removeUserName = (newData) => ({
  type: REMOVE_USER_NAME_DATA,
  payload: newData,
});